import { Box, useMediaQuery, useTheme } from '@mui/material';
import LogoLightSrc from '../../../../../assets/flexeserve_logo_light.png';
import LogoDarkSrc from '../../../../../assets/flexeserve_logo_dark.svg';

function HeaderLogoFlexeserveDemospace() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logoSrc = theme.palette.mode === 'dark' ? LogoDarkSrc : LogoLightSrc;
  return (
    <Box
      component={'img'}
      src={logoSrc}
      alt="Flexeserve Demospace Logo"
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        maxWidth: '150px',
        color: theme.palette.text.primary,
      })}
    />
  );
}

export default HeaderLogoFlexeserveDemospace;
